// Centralized policy & support content for BYONDELMNTS.
// Single source of truth; rendered by /pages/PolicyPage.jsx

export const BRAND = {
  email: "byondelmnts@gmail.com",
  phoneDisplay: "+91 9156333867",
  phoneTel: "+919156333867",
  whatsappDisplay: "+91 9156333867",
  whatsappLink: "https://wa.me/919156333867?text=Hi%20BYONDELMNTS",
  hours: "9:00 AM – 9:00 PM IST · Mon to Sat",
  address: "BYONDELMNTS EXIM LLP, Z3 Bita 507, Roseland Residency Gate 4, Pimplesaudagar, Pune 411027, India",
};

export const POLICIES = {
  shipping: {
    title: "SHIPPING POLICY",
    intro: "We ship across India and select international destinations. Here's everything you need to know about how your order reaches you.",
    sections: [
      {
        heading: "Dispatch Timeline",
        bullets: [
          "Orders placed before 4:00 PM IST are processed the same day.",
          "Orders placed after 4:00 PM IST or on Sundays/holidays are processed the next business day.",
          "All orders ship within 48 hours of confirmation. Drops & pre-orders ship within 7 business days from drop release.",
        ],
      },
      {
        heading: "Delivery Timelines (India)",
        bullets: [
          "Metro cities (Mumbai, Delhi, Bengaluru, Hyderabad, Chennai, Kolkata, Pune): 2–4 business days.",
          "Tier 2 / Tier 3 cities: 4–7 business days.",
          "Remote / North-East / J&K / Andaman: 7–10 business days.",
        ],
      },
      {
        heading: "Shipping Charges",
        bullets: [
          "FREE shipping on orders ₹1,499 and above.",
          "Standard shipping: ₹99 for orders below ₹1,499.",
          "Cash on Delivery (COD): additional ₹49 handling fee, available on orders below ₹3,000.",
          "ELMNTS Club PRO and ELITE members get free priority shipping on every order.",
        ],
      },
      {
        heading: "Courier Partners",
        bullets: [
          "We ship via Shiprocket, Delhivery, Bluedart, DTDC, Ekart, and India Post depending on serviceability of your pincode.",
          "Courier is assigned automatically at the time of dispatch. You can track your shipment from your Orders page or via the link sent in the dispatch SMS/email.",
        ],
      },
      {
        heading: "International Shipping",
        bullets: [
          "We currently ship to UAE, Singapore, UK, USA, Canada, and Australia.",
          "International delivery: 7–14 business days.",
          "Customs duties, taxes, and import fees are borne by the buyer and not included in the order total.",
          "International orders are non-returnable but eligible for replacement of manufacturing defects within 15 days.",
        ],
      },
      {
        heading: "Order Tracking",
        bullets: [
          "Once dispatched, you'll receive an AWB number via email, SMS, and WhatsApp.",
          "Track live status on your Orders page or directly on the courier partner's website.",
          "Need help? WhatsApp us with your order number for instant updates.",
        ],
      },
    ],
  },

  returns: {
    title: "RETURNS & EXCHANGE POLICY",
    intro: "We want you to wear what fits. Easy returns within 15 days of delivery — here's how it works.",
    sections: [
      {
        heading: "Return Window",
        bullets: [
          "Returns are accepted within 15 days of delivery for orders placed outside Sale or Drop events.",
          "Sale, Clearance, and Drop items are FINAL SALE and not eligible for return or exchange.",
        ],
      },
      {
        heading: "Eligibility",
        bullets: [
          "Items must be unworn, unwashed, and in original condition with all tags, hangtags, and inner labels intact.",
          "Original packaging must be returned — including dust bag (where applicable).",
          "We reserve the right to refuse a return if the item appears used, washed, altered, damaged or spoiled.",
        ],
      },
      {
        heading: "Non-Returnable Items (Hygiene Policy)",
        bullets: [
          "Caps, beanies, hats, masks",
          "Socks, boxers, innerwear",
          "Shorts, bodysuits, crop tops, tank tops, baby tees",
          "Scarves, tote bags, stickers and other stationery",
          "Customized / monogrammed orders",
          "Footwear that has been worn outside (try them on indoors only)",
        ],
      },
      {
        heading: "Refund Method",
        bullets: [
          "Refunds are issued to your ELMNTS Wallet as store credit — usable at next checkout, never expires.",
          "Wallet credit is issued within 48 hours of return pickup and quality check.",
          "Shipping fees and COD handling charges are NON-refundable for both prepaid and COD orders.",
          "Bank refunds are available only for orders cancelled before dispatch — credited within 5–7 business days.",
        ],
      },
      {
        heading: "Exchanges",
        bullets: [
          "Free size and color exchanges within 15 days, subject to stock availability.",
          "If the new item costs more, pay the difference upfront via prepaid method.",
          "If the new item costs less, the balance is credited to your ELMNTS Wallet.",
          "If your replacement item is out of stock, we'll refund the full amount + GST to your wallet.",
        ],
      },
      {
        heading: "90-Day Manufacturing Guarantee",
        bullets: [
          "Covered: Hoodies, Cargo Pants, Joggers, Sweatpants, Heavyweight Tees, Supima T-shirts, Cabana Shirts.",
          "Guarantee covers: loose stitching, faulty zippers, fabric pilling, broken hardware, missing prints/embellishments.",
          "Strictly applies to items purchased at full MRP only — NOT applicable on Sale, Clearance, or items bought with discount codes of 30% or more.",
          "Not covered: damage from improper washing, regular wear & tear, accidents, alterations, fabric breakdown from chemicals.",
        ],
      },
      {
        heading: "How to Initiate a Return",
        bullets: [
          "Go to My Orders → select the order → click 'Return / Exchange'.",
          "Choose reason and upload 2–3 clear photos (and an unboxing video for damaged/defective items).",
          "Our Customer Experience team confirms within 48 hours.",
          "Reverse pickup is scheduled by Shiprocket — please re-package the item as delivered.",
          "Once quality-checked at our warehouse, wallet credit is issued within 24 hours.",
        ],
      },
      {
        heading: "Order Cancellation",
        bullets: [
          "Cancellations are accepted only before the order is dispatched from our warehouse — usually within 12 hours of placement.",
          "Post-dispatch cancellations are not allowed; please initiate a return after delivery.",
        ],
      },
    ],
  },

  privacy: {
    title: "PRIVACY POLICY",
    intro: "We respect your data. This policy explains what we collect, why, and how it's protected.",
    sections: [
      {
        heading: "What We Collect",
        bullets: [
          "Contact info: name, email, mobile number, shipping/billing address.",
          "Order data: products purchased, payment method, transaction ID (we never store full card numbers — payments are processed by Razorpay).",
          "Behavioral data: pages viewed, items wishlisted, cart abandonment events. Used to improve recommendations.",
          "Device & log data: IP address, browser, device type, timestamps.",
        ],
      },
      {
        heading: "How We Use Your Data",
        bullets: [
          "Process orders, payments, shipping, and customer support.",
          "Send transactional updates (order confirmation, dispatch, delivery, returns) via Email, SMS, and WhatsApp.",
          "With your consent, send marketing about new drops, sales, and ELMNTS Club rewards. Opt-out anytime.",
          "Detect fraud and prevent abuse of coupon codes / refunds.",
        ],
      },
      {
        heading: "Who We Share With",
        bullets: [
          "Payment processors (Razorpay) for transaction completion.",
          "Logistics partners (Shiprocket, Delhivery, Bluedart, DTDC, etc.) for delivery.",
          "Communication providers (SendGrid for email, Twilio for SMS/WhatsApp).",
          "Analytics (Google Analytics, Meta Pixel) in aggregated/anonymized form.",
          "We DO NOT sell your data to third parties.",
        ],
      },
      {
        heading: "Cookies",
        bullets: [
          "We use cookies to keep you signed in, remember your cart, and personalize recommendations.",
          "You can disable cookies in your browser, but parts of the site (cart, checkout) may not function.",
        ],
      },
      {
        heading: "Your Rights",
        bullets: [
          "Request a copy of all data we hold about you.",
          "Request correction of inaccurate data.",
          "Request deletion of your account (orders are retained 7 years for legal compliance, then permanently deleted).",
          "Email byondelmnts@gmail.com for any of the above.",
        ],
      },
    ],
  },

  terms: {
    title: "TERMS & CONDITIONS",
    intro: "By using BYONDELMNTS.com you agree to these terms. Read them — we made them as un-legal as legally possible.",
    sections: [
      {
        heading: "Account",
        bullets: [
          "You're responsible for keeping your account password safe. Don't share it.",
          "We may suspend or terminate accounts that abuse coupon codes, file fraudulent returns, or violate community standards.",
        ],
      },
      {
        heading: "Pricing & Availability",
        bullets: [
          "Prices are in INR and inclusive of GST unless stated otherwise.",
          "We reserve the right to correct pricing errors — if a price is grossly wrong, we'll cancel and refund your order in full.",
          "Stock is limited, especially on drops. Carting an item does not reserve it; reservation happens at checkout.",
        ],
      },
      {
        heading: "Intellectual Property",
        bullets: [
          "All designs, prints, photography, and copy on BYONDELMNTS.com are the property of BYONDELMNTS EXIM LLP.",
          "Don't reproduce, copy or resell our designs. Don't use our brand name for unauthorized merchandise.",
        ],
      },
      {
        heading: "ELMNTS Club & Wallet",
        bullets: [
          "Wallet credit is non-transferable and cannot be converted to cash.",
          "Points have no monetary value outside the ELMNTS ecosystem.",
          "We reserve the right to revoke wallet credit obtained through fraud or chargebacks.",
        ],
      },
      {
        heading: "Limitation of Liability",
        bullets: [
          "Our liability is capped at the value of the order in question.",
          "We are not liable for indirect damages, lost profits, or third-party courier delays beyond our control.",
        ],
      },
      {
        heading: "Governing Law",
        bullets: [
          "These terms are governed by Indian law. Disputes are subject to the exclusive jurisdiction of the courts at Mumbai.",
        ],
      },
    ],
  },
};

export const POLICY_NAV = [
  { slug: "shipping", label: "SHIPPING" },
  { slug: "returns", label: "RETURNS & EXCHANGE" },
  { slug: "privacy", label: "PRIVACY POLICY" },
  { slug: "terms", label: "TERMS & CONDITIONS" },
];

export const FAQS = [
  {
    category: "ORDERS",
    items: [
      { q: "How do I place an order?", a: "Add items to your cart, proceed to checkout, enter your shipping address, apply any coupon, choose payment method, and pay. You'll receive an order confirmation via Email and WhatsApp." },
      { q: "Can I modify my order after placing it?", a: "You can cancel before dispatch (usually within 12 hours). Modifications (size/color/qty changes) are not supported — cancel and re-order with the correct details." },
      { q: "Can I order via WhatsApp?", a: "Yes! WhatsApp us at " + BRAND.whatsappDisplay + " — our team can take your order and send a secure payment link." },
    ],
  },
  {
    category: "PAYMENTS",
    items: [
      { q: "What payment methods do you accept?", a: "Credit/Debit cards, UPI, Netbanking, Wallets, EMI (cards), and Cash on Delivery (COD) on orders below ₹3,000." },
      { q: "Is COD safe?", a: "Yes — pay in cash when your package arrives. A small handling fee of ₹49 applies. Please count your money and check the package before the courier leaves." },
      { q: "Do you offer prepaid discounts?", a: "Yes — use code PREPAID5 for 5% off on prepaid orders (subject to active campaigns)." },
      { q: "I was charged but order failed. What now?", a: "Failed transactions are auto-refunded by your bank within 5–7 business days. If it doesn't reflect, email us with the transaction reference." },
    ],
  },
  {
    category: "SHIPPING",
    items: [
      { q: "When will my order ship?", a: "Within 48 hours of order confirmation (excluding Sundays/holidays). Drops ship within 7 business days of release." },
      { q: "How do I track my order?", a: "Go to My Orders → click the order → see live tracking. Also sent via SMS/Email/WhatsApp once dispatched." },
      { q: "Do you ship internationally?", a: "Yes — to UAE, Singapore, UK, USA, Canada, Australia. International orders cannot be returned but can be replaced if defective." },
      { q: "Shipping is free?", a: "On orders ₹1,499 and above. Below that, standard shipping is ₹99. ELMNTS Club PRO/ELITE members get free shipping always." },
    ],
  },
  {
    category: "RETURNS & EXCHANGE",
    items: [
      { q: "How long do I have to return an item?", a: "15 days from delivery for non-Sale, non-Drop items. Initiate from My Orders → Return / Exchange." },
      { q: "How do I get my refund?", a: "Refunds are issued as ELMNTS Wallet credit, usable on your next order. Wallet credit never expires." },
      { q: "Can I exchange instead of return?", a: "Yes — free size/color exchange within 15 days, subject to stock. Pay any price difference upfront." },
      { q: "What if my item is defective?", a: "Email a clear unboxing video + photos within 48 hours of delivery to " + BRAND.email + ". Defective items get a free replacement or full wallet refund." },
      { q: "I bought it on Sale — can I return it?", a: "No. Sale, Clearance and Drop items are FINAL SALE." },
    ],
  },
  {
    category: "SIZING & FIT",
    items: [
      { q: "Where can I find the size chart?", a: "Each product page has a SIZE CHART link below the size selector. Also see our full Size Guide." },
      { q: "Do you offer oversized/regular fits?", a: "Both. Check the FIT label on each product (Oversized, Regular, Relaxed, Tapered, etc.)." },
      { q: "What if it doesn't fit?", a: "Initiate a free size exchange within 15 days. We'll arrange a reverse pickup." },
    ],
  },
  {
    category: "ELMNTS CLUB",
    items: [
      { q: "What is ELMNTS Club?", a: "Our 3-tier loyalty programme: Free, Pro (auto-upgraded at ₹15K lifetime spend), and Elite (auto-upgraded at ₹50K)." },
      { q: "How do I earn points?", a: "1 point per ₹100 spent on Free tier; 2x on Pro; 3x on Elite. 1 point = ₹1 at checkout, redeemable up to 10% of any order." },
      { q: "What are member perks?", a: "Early drop access, free priority shipping, birthday bonuses, members-only collabs, and a personal stylist on WhatsApp (Elite tier)." },
      { q: "Does my membership expire?", a: "No. Once you hit a tier, it's yours for life." },
    ],
  },
];

export const SIZE_CHARTS = {
  tops: {
    title: "TOPS (T-SHIRTS, HOODIES, SHIRTS)",
    note: "Measurements in inches. Brand fit is OVERSIZED — size down for a regular fit.",
    cols: ["SIZE", "CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
    rows: [
      ["XS", "38", "26", "18", "8.5"],
      ["S",  "40", "27", "19", "9"],
      ["M",  "42", "28", "20", "9.5"],
      ["L",  "44", "29", "21", "10"],
      ["XL", "46", "30", "22", "10.5"],
      ["XXL","48", "31", "23", "11"],
    ],
  },
  bottoms: {
    title: "BOTTOMS (JEANS, JOGGERS, CARGOS, TROUSERS)",
    note: "Measurements in inches. Pick your waist size; check inseam for length.",
    cols: ["SIZE", "WAIST", "HIP", "INSEAM", "THIGH"],
    rows: [
      ["28", "28", "36", "30", "23"],
      ["30", "30", "38", "30", "24"],
      ["32", "32", "40", "31", "25"],
      ["34", "34", "42", "31", "26"],
      ["36", "36", "44", "32", "27"],
    ],
  },
  footwear: {
    title: "FOOTWEAR (UK / US / EU)",
    note: "Streetwear fits true-to-size; for half sizes, size up.",
    cols: ["UK", "US (MEN)", "US (WOMEN)", "EU", "FOOT LENGTH (CM)"],
    rows: [
      ["6", "7", "8.5", "40", "25.0"],
      ["7", "8", "9.5", "41", "25.7"],
      ["8", "9", "10.5", "42", "26.5"],
      ["9", "10", "11.5", "43", "27.3"],
      ["10", "11", "12.5", "44", "28.0"],
      ["11", "12", "13.5", "45", "28.8"],
    ],
  },
};
